import React from 'react'
import Section4NFT from '../assets/images/Section4NFT.png'
import Section4Metaverse from '../assets/images/Section4Metaverse.png'
import Section4SmartContracts from '../assets/images/Section4SmartContracts.png'
import Section4Trading from '../assets/images/Section4Trading.png'
import Section4DAO from '../assets/images/Section4DAO.png'
import Section4Blockchain from '../assets/images/Section4Blockchain.png'
import Section4DeFi from '../assets/images/Section4DeFi.png'
import Section4Crypto from '../assets/images/Section4Crypto.png'
import { with3DTilt } from './Animations/Tilt'

// Icon data with images & positions
const icons = [
  { src: Section4NFT, alt: 'NFT', position: [0, 1] },
  { src: Section4Metaverse, alt: 'Metaverse', position: [0, 2] },
  { src: Section4Trading, alt: 'Trading', position: [1, 0] },
  { src: Section4Crypto, alt: 'Cryptocurrency', position: [1, 1] },
  { src: Section4Blockchain, alt: 'Blockchain Development', position: [1, 2] },
  { src: Section4DAO, alt: 'DAO', position: [1, 3] },
  { src: Section4SmartContracts, alt: 'Smart Contracts', position: [2, 1] },
  { src: Section4DeFi, alt: 'DeFi', position: [2, 2] },
]

// Apply the 3D Tilt effect to each icon
const TiltedIcon = with3DTilt(({ icon }) => (
  <div className="icon-container">
    <img src={icon.src} alt={icon.alt} />
    <h4>{icon.alt}</h4>
  </div>
))

const IconAnimation = () => {
  return (
    <div className="icon-grid">
      {Array.from({ length: 3 }).map((_, row) => (
        <div key={row} className="grid-row">
          {Array.from({ length: 4 }).map((_, col) => {
            const icon = icons.find((icon) => icon.position[0] === row && icon.position[1] === col)
            return icon ? (
              <TiltedIcon key={icon.alt} icon={icon} className="icon-tilt" />
            ) : (
              <div key={`empty-${row}-${col}`} className="grid-cell"></div> // Empty space
            )
          })}
        </div>
      ))}
    </div>
  )
}

export default IconAnimation
